import axios from "axios";
import { DELETE_CONNECTION_ITEM, GET_ALL_CONNECTION, GET_ALL_CONNECTION_CATEGORY, GET_ALL_CONNECTION_FAILED, GET_ALL_CONNECTION_SUCCESS } from "../../constants/connectionConstants";
import ToastManager from "../../../modules/default/popup/alert/apiNotification";

export const GetAllConnections = (data) => async(dispatch) => {
    dispatch({ type: GET_ALL_CONNECTION });
    try {
        const res = await axios.post(`/card/connects/list`, data);
        
        dispatch({ 
            type: GET_ALL_CONNECTION_SUCCESS, 
            payload: {
                data: res.data.data,
                pagination: res.data.pagination,
                page: data.page
            }
        });
    } catch(error) {
        dispatch({ type: GET_ALL_CONNECTION_FAILED, payload: error.message });
    }
};
export const GetAllConnectionCategory = (data) => async(dispatch) => {
    dispatch({ type: GET_ALL_CONNECTION });
    try {
        const res = await axios.get(`essential/group?type=card_connects`, {params: data});
        
        dispatch({ 
            type: GET_ALL_CONNECTION_CATEGORY, 
            payload: {
                data: res.data.data,
                pagination: res.data.pagination,
                page: data.page
            }
        });
    } catch(error) {
        dispatch({ type: GET_ALL_CONNECTION_FAILED, payload: error.message });
    }
};
export const deleteConnection = (id) => async(dispatch) => {
    const toastId = ToastManager.showLoading('Deleting...');
    try {

        const response = await axios.delete(`/card/connects/delete`, {
            data:{ connectID: id}
        });
        if(response.status >= 200 && response.status < 300){
            ToastManager.showSuccess(toastId, response.data.message || 'Connection deleted successfully!');
            dispatch({ 
                type: DELETE_CONNECTION_ITEM, 
                payload: {
                    id: id
                }
            });
        }

    } catch(err) {
        let errorMsg = Object.values(Error.response.data).join(', ')
        ToastManager.showError(toastId, errorMsg || 'Failed to delete connection.');
    }
};